import { motion } from "framer-motion";
import { PRODUCTS } from "@/lib/site-data";

const PRODUCT_IMG = {
  "Gold Bars": "https://customer-assets.emergentagent.com/job_agroya-refine/artifacts/mc8b4hbs_WhatsApp%20Image%202026-02-25%20at%201.21.36%20PM.jpeg",
  "Silver Bars": "https://customer-assets.emergentagent.com/job_agroya-refine/artifacts/cclj27jw_WhatsApp%20Image%202026-02-26%20at%202.23.13%20PM%20%281%29.jpeg",
  "Custom Bullion": "https://images.pexels.com/photos/30836332/pexels-photo-30836332.jpeg",
  "Minted Products": "https://images.unsplash.com/photo-1592492152545-9695d3f473f4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxtb2x0ZW4lMjBnb2xkJTIwbGlxdWlkfGVufDB8fHx8MTc4MTg2NDU4MXww&ixlib=rb-4.1.0&q=85",
  "Investment Bars": "https://images.pexels.com/photos/6804260/pexels-photo-6804260.jpeg",
};

export default function Products() {
  return (
    <section data-testid="products-section" id="products" className="py-24 lg:py-32 bg-[#F4F9FC]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <div className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] font-semibold">Products</div>
          <h2 className="font-heading mt-3 text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">
            Investment-grade <span className="gold-gradient-text font-medium">bullion</span> & minted products.
          </h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {PRODUCTS.map((p, i) => (
            <motion.article
              key={p.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.07 }}
              whileHover={{ y: -6, rotateX: 2, rotateY: -2 }}
              style={{ transformStyle: "preserve-3d", perspective: 1000 }}
              data-testid={`product-${i}`}
              className="group relative bg-white border border-[#E5E5E5] rounded-xl overflow-hidden lift-card"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={PRODUCT_IMG[p.title]}
                  alt={p.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
              </div>
              <div className="p-6">
                <div className="text-[10px] uppercase tracking-[0.22em] text-[#D4AF37] font-semibold">Agroya Premium</div>
                <h3 className="font-heading mt-2 text-xl font-medium text-[#0A0A0A]">{p.title}</h3>
                <p className="mt-2 text-sm text-[#4B5563] leading-relaxed">{p.desc}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
